<form (ngSubmit)="onSubmit()">
  <input
    cdkOverlayOrigin
    #elementRef="cdkOverlayOrigin"
    *ngIf="!capitalize"
    placeholder="{{ translatedPlaceholder }}"
    [formControl]="searchControl"
    (keydown.enter)="$event.preventDefault()"
  />
  <input
    cdkOverlayOrigin
    #elementRef="cdkOverlayOrigin"
    *ngIf="capitalize"
    placeholder="{{ translatedPlaceholder }}"
    [formControl]="searchControl"
    (keyup)="onInput($event)"
  />

  <sn-icon-button
    [@snZoomIn]
    icon="search"
    type="submit"
    [matTooltip]="'common.search' | t"
    class="sn-searchbar__search-button"
  >
  </sn-icon-button>

  <sn-icon-button
    *ngIf="hasSearchValue"
    [@snZoomIn]
    [@snZoomOut]
    (click)="clear()"
    icon="close"
    [matTooltip]="'common.clearSearch' | t"
    class="sn-searchbar__clear-button"
  >
  </sn-icon-button>
</form>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="elementRef"
  [cdkConnectedOverlayOpen]="isOpen && !!options.length"
  [cdkConnectedOverlayPositions]="overlayPosition"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayWidth]="elementRef?.nativeElement?.offsetWidth"
  (backdropClick)="isOpen = false"
>
  <div class="search-results-container">
    <mat-list class="search-option-list">
      <ng-container *ngFor="let option of options; trackBy: trackOption">
        <div *ngIf="option.isLabel" class="mat-subheader">{{ option.label }}</div>
        <mat-list-item
          *ngIf="!option.isLabel"
          class="search-option-list-items"
          (selected)="onOptionClick(option); option.click()"
          [class.active-item]="option.label === searchControl.value"
          [snNavigableListItem]
        >
          <ng-container *ngIf="option.icon">
            <sn-icon
              matListItemIcon
              [icon]="option.icon.icon"
              [fontSet]="option.icon.fontSet"
              [fontIcon]="option.icon.fontIcon"
              [fontIconUnicode]="option.icon.fontIconUnicode"
              [svgIcon]="option.icon.svgIcon"
            >
            </sn-icon>
          </ng-container>
          <ng-container *ngIf="!option.secondaryLabel">
            <span class="searchbar-primary-text">{{ option.label }}</span>
            <sn-button
              type="button"
              [matTooltip]="'common.whoosterSearch' | t"
              matTooltipPosition="after"
              *ngIf="hasIntegrations() && option.contentType === 'Google Address'"
              (click)="whoosterSearch(option.label)"
            >
              <img class="whooster-icon" src="/assets/fusus-icons/PNG/whooster-icon.png" />
            </sn-button>
          </ng-container>
          <div *ngIf="option.secondaryLabel && !option.attributes" class="searchbar-text-container">
            <div mat-line matListItemTitle class="searchbar-primary-text">
              {{ option.label }}
            </div>
            <div mat-line matListItemLine class="searchbar-secondary-text">
              {{ option.secondaryLabel }}
              <sn-button
                type="button"
                [matTooltip]="'common.whoosterSearch' | t"
                matTooltipPosition="after"
                *ngIf="hasIntegrations() && option.contentType === 'Google Place'"
                (click)="whoosterSearch(option.secondaryLabel)"
              >
                <img class="whooster-icon" src="/assets/fusus-icons/PNG/whooster-icon.png" />
              </sn-button>
            </div>
          </div>
          <div *ngIf="option.secondaryLabel && option.attributes">
            <ng-container [ngSwitch]="option.contentType">
              <ng-container *ngSwitchCase="'cad'">
                <div mat-line matListItemTitle class="searchbar-primary-text">
                  {{ option.attributes['callType'] ? option.attributes['callType'] : option.label }}
                </div>
                <div mat-line matListItemLine class="searchbar-secondary-text">
                  {{ option.secondaryLabel }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'avl'">
                <div mat-line matListItemTitle class="searchbar-primary-text">
                  {{ 'common.unit' | t }}: {{ option.label }}
                </div>
                <div mat-line matListItemLine class="searchbar-secondary-text">
                  {{
                    option.attributes['name'] ? option.attributes['name'] : option.secondaryLabel
                  }}
                </div>
              </ng-container>
            </ng-container>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </div>
</ng-template>
